import Footer from '../Components/Footer';
import Header from '../Components/Header';
import LoginRegister from '../Components/LoginRegister';

function RegLog() {

    return (
        <div>
            <Header/>
            <LoginRegister/>
            <Footer/>
        </div>
    );
}

export default RegLog;